import type { MapStatus } from "./types";

export function statusToIcon(status: MapStatus): string {
    switch (status) {
        case "unknown":
            return "question-square";
        case "processing":
            return "three-dots";
        case "rendered":
            return "check";
        case "framed":
            return "bag-fill";
        case "deleted":
            return "trash";
    }
}

export function statusToColor(status: MapStatus): string {
    switch (status) {
        case "unknown":
            return "gray";
        case "processing":
            return "yellow";
        case "rendered":
            return "lime";
        case "framed":
            return "#b06d02";
        case "deleted":
            return "red";
    }
}

// ---------------------------------------------------------------- //
// Order badges, shared by the Orders and Admin pages.

import type { OrderStatus, PaymentStatus } from "./types";

export function paymentBadge(status: PaymentStatus): { variant: string; label: string } {
    switch (status) {
        case "requires_payment":
            return { variant: "warning", label: "awaiting payment" };
        case "processing":
            return { variant: "info", label: "processing" };
        case "succeeded":
            return { variant: "success", label: "paid" };
        case "free":
            return { variant: "success", label: "free" };
        case "failed":
            return { variant: "danger", label: "failed" };
        case "canceled":
            return { variant: "secondary", label: "canceled" };
        case "refunded":
            return { variant: "secondary", label: "refunded" };
        case "partially_refunded":
            return { variant: "warning", label: "partial refund" };
        default:
            return { variant: "secondary", label: "unknown" };
    }
}

export function fulfillmentBadge(status: OrderStatus): { variant: string; label: string } {
    switch (status) {
        case "pending":
            return { variant: "secondary", label: "pending" };
        case "printing":
            return { variant: "info", label: "printing" };
        case "shipped":
            return { variant: "primary", label: "shipped" };
        case "delivered":
            return { variant: "success", label: "delivered" };
        case "stocked":
            return { variant: "success", label: "stocked" };
        case "canceled":
            return { variant: "secondary", label: "canceled" };
        case "refunded":
            return { variant: "secondary", label: "refunded" };
        default:
            return { variant: "secondary", label: status };
    }
}
